export const ignoredErrors = [
  "Can't find variable: gmo",
  "Cannot read properties of null (reading 'sessionId')",
  "CookieScript is not defined",
  "Envisys-Kontrolldatei fehlt",
  "Expected client-id parameter in sdk url",
  "Failed to fetch",
  "Request aborted",
  "Request failed with status code 422",
  "ResizeObserver is not defined",
  "Right-hand side of 'instanceof' is not an object",
  "SQLSTATE[HY000] [2002] Connection refused",
  "Load failed",
  "TypeError: Load failed",
  "Unexpected end of input",
  "Unexpected token 'else'",
  "Unhandled error response received for message <page-ready>",
  "crypto.randomUUID is not a function",
  "n is undefined",
  "window.AbortController is not a constructor",
  "ReferenceError: UET is not defined",
  "UET is not defined",
  "Can't find variable: UET",
  "Cannot use 'in' operator to search for '36' in null",
];

export const denyUrls = [
  /extensions\//i,
  /^chrome-extension:\/\//i,
  /^safari-extension:\/\//i,
  /^ms-browser-extension:\/\//i,
  /^moz-extension:\/\//i,
  /googletagmanager\.com/i,
  /google-analytics\.com/i,
  /doubleclick\.net/i,
  /connect\.facebook\.net/i,
  /ads\.yieldmo\.com/i,
  /adservice\.google\.com/i,
  /platform\.twitter\.com/i,
  /ajax\.googleapis\.com/i,
  /cdnjs\.cloudflare\.com/i,
  /cdn\.jsdelivr\.net/i,
  /code\.jquery\.com/i,
  /widget\.intercom\.io/i,
  /js\.mollie\.com/i,
  /snap\.aksnap\.net/i,
  /cdn\.taboola\.com/i,
  /localhost/i,
  /127\.0\.0\.1/i,
  /0\.0\.0\.0/i,
  /https?:\/\/integrations\.etrusted\.com.*/i,
  /clickcease\.com.*/i
];
